module.exports = __webpack_public_path__ + "static/img/now-version.8cee9ce0.png";